import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=5be235c0"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetail.vue?vue&type=style&index=0&id=5be235c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports